import {useEffect, useState} from "react";
import Grid from "../Grid";
import GridItem from "../GridItem";
import {br, cl, elStyles, pad} from '../theme';
import cx from '../../../app/editor/utils/makeCls';
import {isDef} from '../../../app/editor/utils/types';
import LabelField from "../LabelField";


const getValue = (value) => isDef(value) ? value : '';

export const getInputClassName = () => {
    return cx('w-full placeholder:italic', cl.bgTr, elStyles.inputText);
}

export default function InputField({
                                       className,
                                       value,
                                       label,
                                       size = 'm',
                                       type,
                                       placeholder,
                                       required,
                                       onInput,
                                       onChange,
                                       onChangeLive
                                   }) {
    const [stateValue, setStateValue] = useState(getValue(value));
    const classInput = getInputClassName();

    useEffect(() => {
        setStateValue(getValue(value));
    }, [value]);

    useEffect(() => {
        onInput?.(stateValue);
    }, [stateValue]);

    const handleChange = (value, partial) => {
        onChange?.(value, partial);
    };

    const handleKeyDown = (ev) => {
        const {key} = ev;

        // eslint-disable-next-line default-case
        switch (key) {
            case 'Escape':
                return setStateValue(value);
            case 'Enter':
                return handleChange(stateValue);
        }
    };

    const handleBlur = (ev) => {
        handleChange(stateValue);
    }

    return (
        <div className={cx(className)}>
            {!!label && <LabelField size={size}>{label}</LabelField>}
            <Grid className={cx(
                cl.bg, br.b, br.rnd,
                cl.br,
                size === 'm' && pad.xy,
                size === 's' && 'px-3 py-1',
            )} items="center" space="x2s">
                <GridItem grow>
                    <input
                        className={classInput}
                        value={stateValue}
                        onChange={(ev) => {
                            setStateValue(ev.target.value);
                            onChangeLive?.(ev.target.value);
                        }}
                        placeholder={placeholder}
                        required={required}
                        onBlur={handleBlur}
                        onKeyDown={handleKeyDown}
                        type={type}
                    />
                </GridItem>
            </Grid>
        </div>
    );
}